import { Controller } from "@hotwired/stimulus";

const getSearchQuery = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("q") || params.get("query") || params.get("s");
};

const webEvent = (type, data = {}) => {
  const urlParams = new URLSearchParams(window.location.search);

  const payload = JSON.stringify({
    event_type: type,
    path: window.location.pathname,
    metadata: {
      ...data,

      referrer: document.referrer,
      utm_source: urlParams.get("utm_source"),
      utm_campaign: urlParams.get("utm_campaign"),
      language: navigator.language,

      screen_width: window.screen.width,
      user_agent: navigator.userAgent,

      load_time: Math.round(performance.now()),
      doc_title: document.title,
      internal_search: getSearchQuery(),
      connection_type: navigator.connection
        ? navigator.connection.effectiveType
        : "unknown",
    },
  });

  navigator.sendBeacon("/api/web_events", payload);
};

export default class extends Controller {
  connect() {
    webEvent("page_view");
  }
}
